export default "__VITE_ASSET__BMJ3Rbn$__"